import { Component, inject, OnInit, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HeaderComponent, FooterComponent } from 'ngx-gov-co-shd';
import { environment } from './../../../environments/environment';
import { RecaptchaComponent } from './../../shared/components/recaptcha/recaptcha.component';
import { DTOTiposDocumentos, ITiposDocumentos, ILinksAyuda, DTOLinksAyuda } from './../../models/login.models'
import { PARAMETRIZACION_FORMULARIO_LOGIN } from './login.component.form';
import { LoginService } from './../../services/http/login.service';
import { AuthService } from '../../services/components/auth.servicice';
import { securityContext } from '../../utils/Security';
import { Router } from '@angular/router';
import { ModalComponent } from '../../shared/components/modal/modal.component';
import { ModalService } from '../../shared/services/modal.service';

declare let gtag: Function;

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule, RecaptchaComponent, HeaderComponent, ModalComponent,FooterComponent],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})

export class LoginComponent implements OnInit {
  passwordVisible = false;
  PARAMETRIZACION_FORMULARIO_LOGIN = PARAMETRIZACION_FORMULARIO_LOGIN;
  tiposDocumentos: ITiposDocumentos[] = DTOTiposDocumentos;
  screenWidth!: number;
  recaptchaMobile = false;
  siteKeyCatchap = environment.siteKeyCatchap;
  recaptchaToken: string | null = null;

  verDialogoInfo = false;
  formLogin!: FormGroup;
  captchaValidado: boolean = true;
  verDialogoRespuesta: boolean = false;
  showViewHTMLComponent = false;
  linksAyuda: ILinksAyuda = DTOLinksAyuda;

  urlInstructivos: string = environment.urlInstructivos;

  constructor(private router: Router,
    private fb: FormBuilder,
    private loginService: LoginService,
    private authService: AuthService, 
    private modalService:ModalService) {
    if (this.authService.isAuthenticated()) {
      this.router.navigate(['/principal']);
      return;
    } else {
      this.showViewHTMLComponent = true;
    }
  }

  ngOnInit() {
    try {
      window.scrollTo(0, 0);
    } catch (error) {
      console.error(error);
    }
    this.formLogin = this.fb.group({
      tipoDocumento: ["", [Validators.required]],
      numeroDocumento: ["", [Validators.required]],
      clave: ["", [Validators.required]]
    });

    this.cargarValoresPorDefecto();
    this.obtenerAyudas()
    this.screenWidth = window.innerWidth;
    this.activarCaptcha();

    if (typeof gtag === 'function') {
      try {
        gtag('event', 'page_view', { page_path: '/OficinaVirtualSIT2/login' });
      } catch (err) {}
    }
  }

  obtenerAyudas() {
    this.loginService.ayudaLogin().subscribe({
      next: (response) => {
        this.linksAyuda.urlAuti = response.urlAuti;
        this.linksAyuda.urlRecuperarClave = response.urlRecuperarClave;
        this.linksAyuda.urlCalendario = response.urlCalendario;
        this.linksAyuda.urlNoticias = response.urlNoticias;
        this.linksAyuda.urlPreguntasFrec = response.urlPreguntasFrec;
        this.linksAyuda.urlEventosTrib = response.urlEventosTrib;
        this.linksAyuda.urlCambiaCorreo = response.urlCambiaCorreo;
        this.linksAyuda.urlInstructivos = response.urlInstructivos;
        this.linksAyuda.urlRecaudoAno = response.urlRecaudoAno;
        this.linksAyuda.urlAyudaDescuento = response.urlAyudaDescuento;
        this.linksAyuda.msgEmergencia = response.msgEmergencia;
      },
      error: (err) => {
        this.modalService.mostrarMensaje(this.modalService.TIPO_MODAL.ERROR, "ERROR", "Error consultando la información del servidor");
      }
    });
  }


  cargarValoresPorDefecto() {
    this.formLogin.get("tipoDocumento")?.setValue("", { emitEvent: false });
    this.formLogin.get("numeroDocumento")?.setValue("", { emitEvent: false });
    this.formLogin.get("clave")?.setValue("", { emitEvent: false });
  }


  setValidators(fields: string[], validator: any) {
    fields.forEach(f => {
      const control = this.formLogin.get(f);
      if (control) {
        control.setValidators(validator);
        control.updateValueAndValidity();
      }
    });
  }

  clearValidators(fields: string[]) {
    fields.forEach(f => {
      const control = this.formLogin.get(f);
      if (control) {
        control.clearValidators();
        control.updateValueAndValidity();
      }
    });
  }

  clearAllValidatorsExcept(exceptions: string[]) {
    Object.keys(this.formLogin.controls).forEach(key => {
      if (!exceptions.includes(key)) {
        this.clearValidators([key]);
      } else {
        this.setValidators([key], Validators.required);
      }
    });
  }

  showResponse(event: Event) {
    this.captchaValidado = true;
  }

  async autenticarse() {
    if (this.formLogin.invalid) {
      return;
    }

    if (this.recaptchaToken == null) {
      return;
    }
    const form = this.formLogin.getRawValue();
    const usuario = {
      tipoId: form.tipoDocumento,
      nroId: form.numeroDocumento,
      password: form.clave
    }
    const data: string = securityContext().encrypt(JSON.stringify(usuario));
    this.loginService.autenticarse(data).subscribe({
      next: (response) => {
        if (response.status == "0") {
          this.authService.setValueUser(response.data);
          this.authService.setValueConfig(response.config);
          this.router.navigate(['/principal']);
        } else {
          if("Usuario o clave no válidos" == response.msg){
            this.modalService.mostrarMensaje(this.modalService.TIPO_MODAL.WARING, "Credenciales inválidas", response.msg);
          }else {
            this.modalService.mostrarMensaje(this.modalService.TIPO_MODAL.WARING, "", response.msg);
          }
        }
      },
      error: (err) => {
        this.modalService.mostrarMensaje(this.modalService.TIPO_MODAL.ERROR, "ERROR", "Error consultando la información del servidor");
      }
    });
  }

  isValid() {
    let valido = true;
    valido = valido && this.formLogin.valid;
    valido = valido && this.recaptchaToken !== null;
    return valido;
  }

  abrirDialogoFinalizacion(respuesta: any) {
    this.verDialogoRespuesta = true;
    this.formLogin.reset();
    this.cargarValoresPorDefecto();
  }

  cerrarDialogoFinalizacion() {
    this.verDialogoRespuesta = false;
    this.formLogin.reset();
    this.cargarValoresPorDefecto();
  }

  abrirDialogoInfo() {
    this.verDialogoInfo = true;
  }

  cerrarDialogoInfo() {
    this.verDialogoInfo = false;
  }

  onRecaptchaSuccess(token: string): void {
    this.recaptchaToken = token;
  }

  onRecaptchaExpired(): void {
    this.recaptchaToken = null;
  }

  onRecaptchaError(): void {
    this.recaptchaToken = null;
    console.error('Error en reCAPTCHA en el componente padre.');
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.screenWidth = window.innerWidth;
    this.activarCaptcha();
  }

  activarCaptcha() {
    let anterior = this.recaptchaMobile;
    if (this.screenWidth <= 780) {
      this.recaptchaMobile = true;
    } else {
      this.recaptchaMobile = false;
    }
    if (anterior != this.recaptchaMobile) {
      this.recaptchaToken = null;
    }
  }

  validarTipoDocumento(setValidator = false) {
    let tipoDocumento: string = this.formLogin.get("tipoDocumento")?.value;
    if (tipoDocumento == "CC") {
      if (setValidator) {
        this.setValidators(['numeroDocumento'], [Validators.required, Validators.pattern(PARAMETRIZACION_FORMULARIO_LOGIN.numeroDocumento.tipoDocumento["CC"].patron)]);
        return;
      } else {
        return PARAMETRIZACION_FORMULARIO_LOGIN.numeroDocumento.tipoDocumento["CC"].mensaje;
      }
    }
    else if (tipoDocumento == "CE") {
      if (setValidator) {
        this.setValidators(['numeroDocumento'], [Validators.required, Validators.pattern(PARAMETRIZACION_FORMULARIO_LOGIN.numeroDocumento.tipoDocumento["CE"].patron)]);
        return;
      } else {
        return PARAMETRIZACION_FORMULARIO_LOGIN.numeroDocumento.tipoDocumento["CE"].mensaje;
      }
    }
    else if (tipoDocumento == "NIT") {
      if (setValidator) {
        this.setValidators(['numeroDocumento'], [Validators.required, Validators.pattern(PARAMETRIZACION_FORMULARIO_LOGIN.numeroDocumento.tipoDocumento["NIT"].patron)]);
        return;
      } else {
        return PARAMETRIZACION_FORMULARIO_LOGIN.numeroDocumento.tipoDocumento["NIT"].mensaje;
      }
    }
    else if (tipoDocumento == "PA") {
      if (setValidator) {
        this.setValidators(['numeroDocumento'], [Validators.required, Validators.pattern(PARAMETRIZACION_FORMULARIO_LOGIN.numeroDocumento.tipoDocumento["PA"].patron)]);
        return;
      } else {
        return PARAMETRIZACION_FORMULARIO_LOGIN.numeroDocumento.tipoDocumento["PA"].mensaje;
      }
    }
    else if (tipoDocumento == "TI") {
      if (setValidator) {
        this.setValidators(['numeroDocumento'], [Validators.required, Validators.pattern(PARAMETRIZACION_FORMULARIO_LOGIN.numeroDocumento.tipoDocumento["TI"].patron)]);
        return;
      } else {
        return PARAMETRIZACION_FORMULARIO_LOGIN.numeroDocumento.tipoDocumento["TI"].mensaje;
      }
    }
    else if (tipoDocumento == "CD") {
      if (setValidator) {
        this.setValidators(['numeroDocumento'], [Validators.required, Validators.pattern(PARAMETRIZACION_FORMULARIO_LOGIN.numeroDocumento.tipoDocumento["CD"].patron)]);
        return;
      } else {
        return PARAMETRIZACION_FORMULARIO_LOGIN.numeroDocumento.tipoDocumento["CD"].mensaje;
      }
    }
    else if (tipoDocumento == "CA") {
      if (setValidator) {
        this.setValidators(['numeroDocumento'], [Validators.required, Validators.pattern(PARAMETRIZACION_FORMULARIO_LOGIN.numeroDocumento.tipoDocumento["CA"].patron)]);
        return;
      } else {
        return PARAMETRIZACION_FORMULARIO_LOGIN.numeroDocumento.tipoDocumento["CA"].mensaje;
      }
    }
    return "";
  }

  togglePasswordVisibility() {
    this.passwordVisible = !this.passwordVisible;
  }
  
}
